import appConfig from '@/configs/appConfig';
import useAxiosClient from './axiosClient';

export default function useAuthClient() {
  const baseUrl = appConfig.apiUrl + '/auth';

  const client = useAxiosClient(baseUrl);

  const login = async (email, password) => {
    return await client.post('/login', { email, password });
  };

  const register = async (params = {}) => {
    return await client.post('/register', params);
  };

  const me = async () => {
    return await useAxiosClient(baseUrl).get('/user');
  };

  const checkUserExists = async (data) => {
    return await client.post('/check-user', data);
  };

  return {
    register,
    login,
    me,
    checkUserExists
  };
}
